import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { firstValueFrom } from 'rxjs';

import { SelectDateComponent } from '@app/shared/select-date/select-date.component';

export interface ConfirmDateData {
  title: string;
  // Message en HTML, valeurs déjà échappées par l'appelant.
  html: string;
  label: string;
  day: Date;
  confirm: string;
  warn?: boolean;
}

// Question qui demande un jour (« Livré le… ») : le sélecteur commun, calendrier ouvert, au lieu d'un champ date de Swal.
@Component({
  selector: 'app-confirm-date-dialog',
  templateUrl: './confirm-date-dialog.component.html',
  styleUrl: './confirm-date-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, SelectDateComponent],
})
export class ConfirmDateDialogComponent {
  private dialogRef = inject<MatDialogRef<ConfirmDateDialogComponent, Date>>(MatDialogRef);
  data: ConfirmDateData = inject(MAT_DIALOG_DATA);
  day: Date | null = this.data.day;

  confirm(): void {
    if (this.day) this.dialogRef.close(this.day);
  }
}

// Ouvre la question, curseur dans le champ (texte sélectionné) ; rend le jour choisi, null si annulé.
export function askDate(dialog: MatDialog, data: ConfirmDateData): Promise<Date | null> {
  const ref = dialog.open<ConfirmDateDialogComponent, ConfirmDateData, Date>(ConfirmDateDialogComponent, { data, width: '520px', maxWidth: '95vw', autoFocus: 'input' });
  return firstValueFrom(ref.afterClosed()).then((day) => day ?? null);
}
